'use client';

import { PaymentPlanType } from '~/types/listingTypes';
import { useTranslation } from 'react-i18next';
import DurationDate from '~/components/DurationDate';
import { formatNumber } from '~/lib';
import formatCompactNumber from '~/utils/formatCompactNumber';

export default function ListingInstallmentsPlan({
  plan,
  locale,
}: {
  plan: PaymentPlanType;
  locale: string;
}) {
  const { t } = useTranslation('app');

  return (
    <div className="flex flex-wrap gap-x items-center">
      <div className="flex gap-0.5x">
        <span className="text-caption-2 text-gray__dark_1">
          {t('downPayment')}
        </span>
        <span className="text-caption-2 text-black">
          {locale === 'en'
            ? formatCompactNumber(Number(plan.down_payment), {
                thousands: t('thousands'),
                millions: t('millions'),
                billions: t('billions'),
              })
            : formatNumber(Number(plan.down_payment))}
        </span>
        <span className="text-caption-1 text-gray__dark_2">
          {t('currencyEg')}
        </span>
      </div>

      <div className="flex items-center h-full ">
        <div className="w-[1px] h-[16px]  bg-gray"></div>
      </div>

      <div className="flex gap-0.5x">
        <span className="text-caption-2 text-gray__dark_2">{t('upTo')}</span>
        <DurationDate
          days={plan.duration}
          classNames={{
            value: 'text-caption-2 text-black',
            text: 'text-caption-2 text-gray__dark_2  ',
          }}
          visibleParts={{ months: true, years: true }}
        />
      </div>
    </div>
  );
}
